import { Chain, ESortChainsType } from '@ankr.com/chains-list';

import { SortPrivateChainsParams } from '../PrivateChainsTypes';
import { aggregateTotalRequestsNumber } from './aggregateTotalRequestsNumber';
import { getChainIDs } from './getChainIDs';

export const sortPrivateChains = ({
  blockchainsCountsMap,
  chains: rawChains = [],
  sortType,
}: SortPrivateChainsParams): Chain[] => {
  if (!Array.isArray(rawChains)) return [];

  const privateChainsUsageSorter = (a: Chain, b: Chain) =>
    aggregateTotalRequestsNumber({
      blockchainsCountsMap,
      ids: getChainIDs(b),
    }) -
    aggregateTotalRequestsNumber({
      blockchainsCountsMap,
      ids: getChainIDs(a),
    });

  const sorter =
    sortType === ESortChainsType.UsageHighLow
      ? privateChainsUsageSorter
      : () => 0;

  const sortedChains = [...rawChains].sort(sorter);

  return [...sortedChains];
};
